import { Box } from '@chakra-ui/react';

interface CommandChipProps {
  /** The slash command, e.g. "/salarybenchmark". */
  cmd: string;
}

// The leading slash command in a sent message, highlighted like a mention so
// it reads the same as it did in the composer.
export const CommandChip = ({ cmd }: CommandChipProps) => (
  <Box
    as="span"
    display="inline-block"
    px="6px"
    mx="1px"
    borderRadius="6px"
    bg="primary-50"
    color="primary-700"
    fontWeight={500}
    sx={{ whiteSpace: 'nowrap', verticalAlign: 'baseline' }}
  >
    {cmd}
  </Box>
);
